import { Zap, Pickaxe, Car, ShoppingBag, HeartPulse, GraduationCap, Building2 } from "lucide-react";

const SEGMENTOS = [
    { icon: Zap, name: "Energia & Infraestrutura" },
    { icon: Pickaxe, name: "Mineração & Indústria Pesada" },
    { icon: Car, name: "Automotivo & Serviços Premium" },
    { icon: ShoppingBag, name: "Comércio & Soluções Industriais" },
    { icon: HeartPulse, name: "Saúde" },
    { icon: GraduationCap, name: "Educação & Sindicatos" },
    { icon: Building2, name: "Condomínios" },
];

export default function Cases() {
    const loop = [...SEGMENTOS, ...SEGMENTOS];
    return (
        <section
            id="cases"
            data-testid="cases-section"
            className="relative py-24 sm:py-32 border-t border-zinc-200 dark:border-white/5 overflow-hidden bg-background"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8">
                <div className="max-w-3xl">
                    <span className="inline-block text-xs font-bold uppercase tracking-[0.22em] text-[#2DA89E]">
                        Cases de sucesso
                    </span>
                    <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-zinc-950 dark:text-white leading-tight">
                        Operações de confiança em setores que não admitem falhas.
                    </h2>
                    <p className="mt-6 text-zinc-600 dark:text-zinc-400 text-base sm:text-lg leading-relaxed">
                        Atuamos com contratantes de diferentes portes e segmentos, sempre com o mesmo padrão de excelência operacional.
                    </p>
                </div>
            </div>

            {/* Marquee */}
            <div className="mt-14 relative">
                <div className="absolute inset-y-0 left-0 w-24 sm:w-40 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
                <div className="absolute inset-y-0 right-0 w-24 sm:w-40 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
                <div className="flex gap-4 animate-marquee" style={{ width: "max-content" }}>
                    {loop.map((s, i) => (
                        <SegmentChip key={i} icon={s.icon} name={s.name} index={i} />
                    ))}
                </div>
            </div>

            {/* Grid summary */}
            <div className="max-w-7xl mx-auto px-6 sm:px-8 mt-16">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-zinc-200 dark:bg-white/5 rounded-3xl overflow-hidden border border-zinc-200 dark:border-white/5">
                    <Stat number="7+" label="Segmentos atendidos" />
                    <Stat number="6" label="Linhas de serviço" />
                    <Stat number="24/7" label="Operações ativas" />
                    <Stat number="BR" label="Cobertura nacional" highlight />
                </div>
            </div>
        </section>
    );
}

function SegmentChip({ icon: Icon, name, index }) {
    return (
        <div
            data-testid={`segmento-chip-${index}`}
            className="shrink-0 flex items-center gap-3 px-6 py-4 rounded-full border border-zinc-200 dark:border-white/10 bg-white dark:bg-[#0d0d0d] shadow-sm dark:shadow-none"
        >
            <span className="w-8 h-8 rounded-full bg-[#2DA89E]/10 text-[#2DA89E] flex items-center justify-center">
                <Icon className="w-4 h-4" />
            </span>
            <span className="text-sm sm:text-base text-zinc-900 dark:text-white whitespace-nowrap">{name}</span>
        </div>
    );
}

function Stat({ number, label, highlight }) {
    return (
        <div
            data-testid={`case-stat-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className="bg-white dark:bg-[#0a0a0a] p-7 sm:p-10"
        >
            <div className={`font-heading text-4xl sm:text-5xl font-black tracking-tight ${highlight ? "text-[#E89546]" : "text-zinc-950 dark:text-white"}`}>
                {number}
            </div>
            <div className="mt-2 text-xs sm:text-sm text-zinc-600 dark:text-zinc-400 uppercase tracking-wider">{label}</div>
        </div>
    );
}
